module.exports = __webpack_public_path__ + "img/videooutline.6f069a5e.png";